// import { motion } from "framer-motion"
// import { Building2 } from "lucide-react"
import bmbf from "../assets/bmbf.png"
import idia from "../assets/idia.png"

const logos = [
  {
    src: bmbf,
    alt: "BMBF Logo",
  },
  {
    src: idia,
    alt: "IDiA Logo",
  },
]

export function Foerderung() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-gradient-to-tr from-black/10 to-transparent blur-3xl" />
        <div className="absolute -right-24 top-32 h-72 w-72 rounded-full bg-gradient-to-tr from-gray-400/20 to-transparent blur-3xl" />
      </div>

      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 space-y-12">
        {/* Logos */}
        {logos.length > 0 && (
          <div className="grid grid-cols-2 gap-6 max-w-xl mx-auto items-center">
            {logos.map((logo, i) => (
              <div key={i} className="flex items-center justify-center rounded-2xl border p-6 bg-white/40 backdrop-blur">
                <img src={logo.src} alt={logo.alt} className="max-h-24 w-auto object-contain" />
              </div>
            ))}
          </div>
        )}

        {/* <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto rounded-3xl border bg-white/40 backdrop-blur p-8 text-center space-y-3">
          <Building2 className="h-6 w-6 mx-auto" />
          <h3 className="font-semibold text-lg">Offiziell gefördertes Bildungsprojekt</h3>
          <p className="text-sm text-gray-600">Entwicklung digitaler Bildungsinnovationen im Schulkontext</p>
        </motion.div> */}
      </div>
    </section>
  )
}
